export default __webpack_public_path__ + "media/globalBillingHubPreview1.f713e.png";